import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WheelState } from "./wheel.state";
import { WheelPrizesData, WheelSpinData } from "./wheel.types";
import { getWheelPrizes, spinWheel } from "./wheel.thunk";

const initialState: WheelState = {
  prizes: { data: null, status: "idle", error: null },
  spin: { data: null, status: "idle", error: null },
};

export const wheelSlice = createSlice({
  name: "wheel",
  initialState,
  reducers: {
    resetWheel: () => initialState,
    resetSpin: (state) => {
      state.spin = { data: null, status: "idle", error: null };
    },
  },
  extraReducers: (build) => {
    build
      // Prizes
      .addCase(getWheelPrizes.pending, (state) => {
        state.prizes.status = "loading";
        state.prizes.error = null;
      })
      .addCase(
        getWheelPrizes.fulfilled,
        (state, action: PayloadAction<WheelPrizesData>) => {
          state.prizes.status = "success";
          state.prizes.data = action.payload;
        },
      )
      .addCase(
        getWheelPrizes.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.prizes.status = "error";
          state.prizes.error = action.payload ?? "Ödüller yüklenemedi.";
        },
      )

      // Spin
      .addCase(spinWheel.pending, (state) => {
        state.spin.status = "loading";
        state.spin.error = null;
      })
      .addCase(
        spinWheel.fulfilled,
        (state, action: PayloadAction<WheelSpinData>) => {
          state.spin.status = "success";
          state.spin.data = action.payload;
        },
      )
      .addCase(
        spinWheel.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.spin.status = "error";
          state.spin.error = action.payload ?? "Çark çevrilemedi.";
        },
      );
  },
});

export const { resetWheel, resetSpin } = wheelSlice.actions;
export default wheelSlice.reducer;
